// Filters.js

import React, { useEffect, useState } from "react";
import "./Filters.scss";

const Filters = ({ regions, onFilterChange }) => {
  const [filterRegion, setFilterRegion] = useState("region-all");

  const handleRegionClick = (region) => {
    // Update the state with the new region
    setFilterRegion(region);

    // Create a new URLSearchParams object with the current query parameters
    // const searchParams = new URLSearchParams(window.location.search);

    // // Set or update the 'region' parameter with the new value
    // searchParams.set("region", region);

    // // Update the browser URL with the new parameters
    // const newUrl = `${window.location.origin}${
    //   window.location.pathname
    // }?${searchParams.toString()}`;
    // window.history.pushState({ path: newUrl }, "", newUrl);

    // Trigger the onFilterChange callback with the new region
    onFilterChange(region);
  };

  return (
    <div className="region-filters">
      <div
        onClick={() => handleRegionClick("region-all")}
        className={`single-region-tab region-all ${
          filterRegion === "region-all" ? "active-region-tab" : ""
        }`}
      >
        All regions
      </div>
      {regions?.map((region) => {
        return (
          <div
            key={`region-${region.toLowerCase()}`}
            onClick={() => handleRegionClick(`region-${region.toLowerCase()}`)}
            className={`single-region-tab ${
              filterRegion === `region-${region.toLowerCase()}`
                ? "active-region-tab"
                : ""
            }`}
          >
            {region}
          </div>
        );
      })}
    </div>
  );
};

export default Filters;
